import type { ISetupGuideCampaignUrlRedirect } from '~/modules/campaign-url-redirect/types';
import type { ISetupGuideCGTemplate } from '~/modules/campaign-group-template/types';
import type { ISetupGuideCampaignTemplate } from '~/modules/campaign-template/types';
import type { ISetupGuideCampaignPrice } from '~/modules/campaign-price/types';

export type TSetupGuideId =
  | ISetupGuideCampaignTemplate
  | ISetupGuideCGTemplate
  | ISetupGuideCampaignPrice
  | ISetupGuideCampaignUrlRedirect;

export interface IGSetupGuideItem<T extends string = string> {
  id: T;
  title: string;
  /** An array renders as a bullet list. */
  description: string | string[];
  completed: boolean;
  /** Hides "Show me" once the step is genuinely done rather than merely acknowledged. */
  isHiddenAction?: boolean;
  /** Disables "Show me" and doubles as its tooltip. */
  disabledReason?: string;
  /** Completion is driven by the user's real action, so "Show me" must not mark it done. */
  isMarkDoneByAction?: boolean;
}

/** Shop meta starts out as `{}` and only ever gains the steps the shop has completed. */
export type IGSetupGuideStatuses = Partial<Record<ISetupGuideCampaignTemplate, boolean>>;

export type IGSetupGuideCGTemplateStatuses = Partial<Record<ISetupGuideCGTemplate, boolean>>;

export enum ISetupGuideButtonStatus {
  NORMAL = 'normal',
  DISABLED = 'disabled',
  HIDDEN = 'hidden',
}
